import {
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_APROVADO,
  PROJECT_STATUS_REJEITADO,
} from '../library/ProjectStatus';

export const isGeneratingPdfById = (arr, id) => {
  return arr.indexOf(id) > -1 ? true : false;
};

export const getAvaliacoesWithStatus = (avaliacoes, status) => {
  let croppedAvaliacoes;
  if (avaliacoes && avaliacoes.length >= 10) {
    croppedAvaliacoes = avaliacoes.splice(0, 10);
    if (typeof croppedAvaliacoes[0] === 'number') {
      return croppedAvaliacoes.filter((item) =>
        String(item) === status.toString() ? true : false
      );
    } else if (typeof croppedAvaliacoes[0] === 'object') {
      return croppedAvaliacoes.filter(
        (avaliacao) => String(avaliacao.status) === status.toString()
      );
    }
  }
  return [];
};

export const projectIsTotalApproved = (avaliacoes) => {
  const total = getAvaliacoesWithStatus(
    avaliacoes,
    PROJECT_STATUS_APROVADO
  ).length;
  return total === 10 ? true : false;
};

export const getMockedProjeto = () => {
  return {
    /* integer */
    id: 5,

    /* string */
    codigoCooperativa: '0101',

    /* string[] */
    cpfsAssessores: ['11122233344', '11122233345'],

    /* string[] */
    cpfsProfessores: ['11122233344', '11122233345'],

    /* string */
    descricaoTurma: 'descricaoTurma',

    /* integer */
    idEscola: 3,

    /* integer[] */
    idEtapasEnsino: [2, 3],

    /* string */
    idUsuario: 'teste_ldap',

    /* Nome do projeto */
    nome: 'nome',

    /* integer */
    quantidadeAlunosTurma: 15,

    /* string date */
    dataCadastro: '2019-04-05T15:15:59',
    dataAlteracao: '2019-04-05T17:19:08',

    /* string */
    justificativa: 'justificativa',

    /* boolean */
    consultaPublica: true,

    /* object[]
    [
      {
        comentario	string
        cpfAcessor	string
        etapa	integer($int32) ( 0 ... )
        status	integer($int32) ( 0 - rascunho / 1 - pendente / 2 - aprovado / 3 - rejeitado )
        existe	boolean
      }
    ]
    */
    avaliacoes: [
      {
        comentario: null,
        cpfAcessor: null,
        etapa: 0,
        status: 2,
        existe: false,
      },
      {
        comentario: null,
        cpfAcessor: null,
        etapa: 1,
        status: 2,
        existe: false,
      },
      {
        comentario: null,
        cpfAcessor: null,
        etapa: 2,
        status: 2,
        existe: false,
      },
      {
        comentario: null,
        cpfAcessor: null,
        etapa: 3,
        status: 2,
        existe: false,
      },
      {
        comentario: null,
        cpfAcessor: null,
        etapa: 4,
        status: 2,
        existe: false,
      },
      {
        comentario: null,
        cpfAcessor: null,
        etapa: 5,
        status: 2,
        existe: false,
      },
      {
        comentario: null,
        cpfAcessor: null,
        etapa: 6,
        status: 2,
        existe: false,
      },
      {
        comentario: null,
        cpfAcessor: null,
        etapa: 7,
        status: 2,
        existe: false,
      },
      {
        comentario: null,
        cpfAcessor: null,
        etapa: 8,
        status: 2,
        existe: false,
      },
    ],

    /* boolean */
    cienciaCordenador: true,

    /* string */
    descricaoPerguntaExploratoria: 'descricaoPerguntaExploratoria',

    /* string */
    descricaoTerritorioInvestigado: 'descricaoTerritorioInvestigado',

    /* string */
    descricaoObjetivoExpedicao: 'descricaoObjetivoExpedicao',

    /* string */
    descricaoExpedicao: 'descricaoExpedicao',

    /* string */
    descricaoPerguntas: 'descricaoPerguntas',

    /* string */
    descricaoIndiceInicial: 'descricaoIndiceInicial',

    /* string */
    descricaoIndiceFormativo: 'descricaoIndiceFormativo',

    /* string */
    descricaoComponenteCurricular: 'descricaoComponenteCurricular',

    /* string */
    descricaoAtividadeDesenvolvida: 'descricaoAtividadeDesenvolvida',

    /* integer[] */
    idPrincipiosValores: [2, 3],

    /* string */
    descricaoPrincipioValor: 'descricaoPrincipioValor',

    /* string */
    descricaoComunidadeAprendizagem: 'descricaoComunidadeAprendizagem',

    /* string */
    descricaoAtividadeIntegradora: 'descricaoAtividadeIntegradora',

    /* string */
    descricaoIndiceFinal: 'descricaoIndiceFinal',

    /* string */
    descricaoMostraPedagogica: 'descricaoMostraPedagogica',
    documentos: [],
  };
};

export const getProjectFilesByEtapa = (images, stepIndex, id) => {
  let arr = images.filter((item) => {
    return item.idProjeto === id && item.etapa === stepIndex ? true : false;
  });
  return arr;
};

export const getProjectFilesOfOtherEtapas = (images, stepIndex, id) => {
  return images.filter((item) => {
    return item.idProjeto === id && item.etapa !== stepIndex ? true : false;
  });
};

export const etapaIsUnlocked = (stepIndex, avaliacoes) => {
  if (stepIndex === 0) {
    return true;
  }
  if (stepIndex < avaliacoes.length) {
    switch (avaliacoes[stepIndex - 1].status) {
      case PROJECT_STATUS_PENDENTE:
      case PROJECT_STATUS_APROVADO:
      case PROJECT_STATUS_REJEITADO:
        return true;
      default:
        return false;
    }
  }
  return false;
};
